export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-indexlist/index.js